import styled from 'styled-components';

export const Wrapper = styled.div`
  .image-box {
    margin: 20px;
    height: 300px;
    width: 350px;
    border: 3px solid #05ae4b;
    border-radius: 5px;
    padding: 5px;
  }
  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 10px;
    padding: 25px 0px;
    margin: 15px;

    > div {
      background-color: #f4f7f8;
      border-radius: 5px;
      text-align: center;
      font-size: 12px;
    }
  }
`;
